/**
 * Donor Service
 *
 * API service for donor-related operations
 */

import { getApiClient } from './client';

export interface Donor {
  donorId: number;
  namePrefix?: string;
  completeName?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  suffix?: string;
  companyName?: string;
  taxReceiptName?: string;
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  countryCode?: string;
  phoneNumber?: string;
  eMail?: string;
  occupation?: string;
  physician?: boolean;
  incorrectAddress?: boolean;
  publishinDonorList?: boolean;
  taxReceiptRequired?: boolean;
  statusCode?: number;
  createdBy?: number;
  createdDate?: string;
  modifiedBy?: number;
  modifiedDate?: string;
}

export interface DonorResponse {
  item: Donor | null;
  status: string;
  message?: string;
}

/**
 * Get the current authenticated user's donor profile
 * Requires authentication token
 *
 * @returns Promise with the donor profile (null if not yet linked/approved)
 */
export async function getCurrentUserDonor(): Promise<DonorResponse> {
    const apiClient = getApiClient();
  const response = await apiClient.get<DonorResponse>('/donors/me');
  return response.data;
}

/**
 * Get donor by ID
 *
 * @param donorId - The donor ID
 * @returns Promise with the donor
 */
export async function getDonorById(donorId: number): Promise<Donor> {
    const apiClient = getApiClient();
    const response = await apiClient.get<DonorResponse>(`/donors/${donorId}`);    
    return response.data.item as Donor;
}

/**
 * Get donor by email
 *
 * @param email - The donor email
 * @returns Promise with the donor
 */
export async function getDonorByEmail(email: string): Promise<Donor> {
    const apiClient = getApiClient();
    const response = await apiClient.get<DonorResponse>(`/donors/by-email/${encodeURIComponent(email)}`);
    return response.data.item as Donor;
}
